import React from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';

import PieChartTooltip from './PieChartTooltip';
import styles from './ExpensesMonthly.scss';

const ExpensesMonthlyChart = ({ selectedExpensesData, disabledItems }) => (
  <div className={styles.width50}>
    <div className={`${styles.chart}`}>
      {selectedExpensesData && (
        <PieChart width={240} height={200}>
          <Pie
            isAnimationActive
            data={selectedExpensesData.map(data => {
              if (disabledItems.includes(data.id.toString())) {
                return { ...data, number: 0 };
              }
              return data;
            })}
            nameKey="name"
            dataKey="number"
            outerRadius={90}
          >
            {selectedExpensesData.map((entry, index) => <Cell id="chart-pie-cell" key={`cell-${index + 1}`} fill={entry.color} />)}
          </Pie>
          <Tooltip content={<PieChartTooltip />} />
        </PieChart>
      )}
    </div>
  </div>
);

export default ExpensesMonthlyChart;
